import ControlsForm from 'forms/ftacabats/controls'
import DescriptionForm from 'forms/ftacabats/description'
import EdgesForm from 'forms/ftacabats/edges'
import FeaturesForm from 'forms/ftacabats/features'
import FoulardsFinishForm from 'forms/ftacabats/foulardsFinish'
import LastAcceptedRequest from 'forms/ftacabats/lastAcceptedRequest'
import OpenMachineForm from 'forms/ftacabats/openMachine'
import PackagingForm from 'forms/ftacabats/packaging'
import RamForm from 'forms/ftacabats/ram'
import RamStatusCheck from 'forms/ftacabats/ramStatusCheck'
import UltrasonicSettings from 'forms/ftacabats/ultrasonicSettings'
import PropTypes from 'prop-types'

export default function Block({ title, className, users, values }) {
  return (
    <div
      className={`${className && className} 
      bg-white rounded border-2 print:border border-blue-200 border-collapse shadow-md print:shadow-none`}
      style={{
        pageBreakInside: 'avoid'
      }}
    >
      <div className="flex items-center justify-start w-full py-2 pl-2 text-sm uppercase bg-blue-200 print:py-1 print:px-1 font-ms-bold">
        {title}
      </div>

      {(() => {
        switch (title) {
          case 'Descripció':
            return <DescriptionForm users={users} values={values} />
          case 'Característiques':
            return <FeaturesForm values={values} />
          case "Màquina d'obrir":
            return <OpenMachineForm values={values} />
          case 'Reglatges ultrasons':
            return <UltrasonicSettings values={values} />
          case 'Acabats foulard':
            return <FoulardsFinishForm values={values} />
          case 'Vores':
            return <EdgesForm values={values} />
          case 'Controls':
            return <ControlsForm values={values} />
          case 'Embalatge':
            return <PackagingForm values={values} />
          case 'Comprovació estat RAM':
            return <RamStatusCheck values={values} />
          case 'Reglatges RAM':
            return <RamForm values={values} />
          case 'Última modificació':
            return <LastAcceptedRequest values={values} />
          default:
            return null
        }
      })()}
    </div>
  )
}

Block.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  users: PropTypes.array,
  values: PropTypes.object
}
